import React from "react";

// Wrap matching substrings of `phrases` in <strong> within `text`.
export const renderWithBold = (
  text: string,
  phrases?: string[]
): React.ReactNode => {
  if (!phrases || phrases.length === 0) return text;
  let nodes: React.ReactNode[] = [text];
  phrases.forEach((phrase, pIdx) => {
    nodes = nodes.flatMap((node, nIdx) => {
      if (typeof node !== "string") return [node];
      const parts = node.split(phrase);
      if (parts.length === 1) return [node];
      const out: React.ReactNode[] = [];
      parts.forEach((part, sIdx) => {
        if (part) out.push(part);
        if (sIdx < parts.length - 1) {
          out.push(
            React.createElement(
              "strong",
              { key: `b-${pIdx}-${nIdx}-${sIdx}` },
              phrase
            )
          );
        }
      });
      return out;
    });
  });
  return nodes;
};
